module.exports = __webpack_public_path__ + "static/media/risk1.94fe3cb4.jpg";